import React from 'react'
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params'

export const useGeneralPromptsQueryParams = () => {
  const [query, setQuery] = useQueryParams(
    {
      page: NumberParam,
      search: StringParam,
      keywords: withDefault(StringParam, ''),
    },
    { removeDefaultsFromUrl: true }
  )

  const { page, search, ...restQuery } = query

  const filters = {
    ...restQuery,
  }

  const onPageChange = (page?: number) => {
    setQuery({ page })
  }

  const onSearchChange = (search?: string) => {
    setQuery({ search })
  }

  const onFiltersChange = (data?: object) => {
    const params = {
      ...data,
    }

    setQuery({ page: undefined, ...params })
  }

  return {
    query,
    setQuery,
    page,
    onPageChange,
    search,
    onSearchChange,
    filters,
    onFiltersChange,
  }
}
